import type { ApiAttachmentDownloadResponse } from '@Model';
import { isOk, type Result, useToasts, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';

/**
 * Resolves a fresh download URL for a single, already-known attachment, without fetching the
 * owning entity's full attachment list (unlike {@link useEntityAttachments}). Used to
 * download a raw attachment referenced from elsewhere (e.g. a print option's attachment list).
 */
export function useAttachmentDownloadUrl(baseUrl: string, entityPath: string, entityId: string) {
    const http = useSynqoHttp(`${baseUrl}/${entityPath}/${entityId}/attachments`);
    const { pushToast } = useToasts();

    return useMutation({
        mutationFn: async (attachmentId: string): Promise<string> => {
            const response = await http.get<Result<ApiAttachmentDownloadResponse>>(`/${attachmentId}:download`);
            if (!response || !isOk(response)) {
                pushToast({ message: 'Download-Link konnte nicht geladen werden.', variant: 'error' });
                throw new Error('Could not retrieve download URL');
            }
            return response.data.download_url;
        },
    });
}
